import React from 'react';
import PropTypes from 'prop-types';
import { faAngleDoubleLeft } from '@fortawesome/free-solid-svg-icons';
import { CPButton } from './styles';

export function AllLeftButton({
  content, onClick, disabled, title, className,
}) {
  return (
    <CPButton
      onClick={onClick}
      disabled={disabled}
      content={content}
      icon={faAngleDoubleLeft}
      title={title}
      className={className}
    />
  );
}

AllLeftButton.propTypes = {
  content: PropTypes.string,
  onClick: PropTypes.func,
  disabled: PropTypes.bool,
  title: PropTypes.string,
  className: PropTypes.string,
};

AllLeftButton.defaultProps = {
  onClick: () => null,
  content: '',
  disabled: false,
  title: '',
  className: '',
};

export default AllLeftButton;
